/** @format */
import { RuleValidationResultFor } from 'common-typescript';
import { EntityWithRule, Rule } from 'common-typescript/types';
import { PlanStateObject } from './plan-state.service';

/**
 * The validation result of `rule` of `parentModule`, typed by the rule type. The state of the education or the module carries the
 * validator's results of its rules by the rules' local ids, so the result found there is always of the rule's own type.
 */
export function getRuleValidationResultFromState<R extends Rule>(
    planStateObject: PlanStateObject,
    parentModule: EntityWithRule,
    rule: R,
): RuleValidationResultFor<R> | undefined {
    const parentState = parentModule.type === 'Education' ? planStateObject.education : planStateObject.modules[parentModule.id];
    return parentState?.ruleValidationResults[rule.localId] as RuleValidationResultFor<R> | undefined;
}
